(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kawaaa-service"] && !Shopify.designMode) return;
  try {
    
/* Barre d'achat collante sur mobile : visible quand le bouton du haut n'est plus à l'écran */
(function () {
  function init() {
    document.querySelectorAll('[data-kse]').forEach(function (root) {
      var bar = root.querySelector('[data-kse-sticky]');
      var buy = root.querySelector('.kse-buy');
      if (!bar || !buy || !('IntersectionObserver' in window)) return;
      new IntersectionObserver(function (e) { bar.hidden = e[0].isIntersecting || e[0].boundingClientRect.top > 0; }).observe(buy);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
